'use client';

import { useVisitorTracking } from '@/hooks/useVisitorTracking';

/**
 * Invisible component that tracks visitor presence on the site.
 * Add to layout.tsx to enable visitor tracking.
 */
export function VisitorTracker() {
    useVisitorTracking();
    return null;
}
